import React from "react";
import BriaButton, { ButtonTypes } from "../BriaButton/BriaButton";
import styles from "./StoppableButton.module.scss";

interface StoppableButtonProps {
	condition: boolean | null;
	onStopButtonClick: () => void;
	onButtonClick: () => Promise<void> | void;
	disabled?: boolean;
	buttonLabel: string | JSX.Element;
	stopButtonLabel?: string | JSX.Element;
	buttonType?: ButtonTypes;
	fullWidth?: boolean;
	size?: "small" | "medium" | "large";
	className?: string;
	disabledTooltip?: string;
}

const StoppableButton: React.FC<StoppableButtonProps> = ({
	condition,
	onStopButtonClick,
	onButtonClick,
	disabled = false,
	buttonLabel,
	stopButtonLabel = "Stop",
	buttonType = "primaryMedium",
	fullWidth = true,
	size = "large",
	className = "",
	disabledTooltip = "",
}) => {
	return condition ? (
		<BriaButton
			buttonType={buttonType}
			fullWidth={fullWidth}
			onClick={onStopButtonClick}
			className={`${styles.stopButton} ${className}`}
			size={size}
			disabledTooltip={disabledTooltip}
		>
			{stopButtonLabel}
		</BriaButton>
	) : (
		<BriaButton
			buttonType={buttonType}
			fullWidth={fullWidth}
			disabled={disabled}
			onClick={onButtonClick}
			className={`${styles.startButton} ${className}`}
			size={size}
			disabledTooltip={disabledTooltip}
		>
			{buttonLabel}
		</BriaButton>
	);
};

export default StoppableButton;
